import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core";
import {getPersonName, mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";
import FormDate from "../Form/FormDate";
// import { DatePicker, TimePicker } from 'material-ui-pickers';

class ScheduleFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false
        };
    }

    toggleCompany(e) {
        this.props.handleChange(e);
        this.state.showCompany = ! this.state.showCompany;
    }

    render() {
        const {
            values,
            course,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFormikState,
            formUrl,
            isEdit
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="id_course" value={values.id_course} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6}>
                        <FormField
                            type="text"
                            disabled
                            autoComplete={false}
                            name="course_name"
                            label={i18n.get('schedules.course_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={course.name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete
                            name="id_person"
                            label={i18n.get('schedules.lecturer')}
                            url="/search-lecturer"
                            onChange={option => {
                                values.id_person = option.value;
                                if ( option.entity ) {
                                    values.lecturer = option.entity
                                }
                                setFormikState({values});
                            }}
                            onBlur={handleBlur}
                            defaultOptions={values.lecturer && [{
                                'value': values.lecturer.id,
                                'label': getPersonName(values.lecturer),
                                'entity': values.lecturer,
                            }]}
                            value={values.lecturer && {
                                'value': values.lecturer.id,
                                'label': getPersonName(values.lecturer),
                                'entity': values.lecturer,
                            }}
                            error={errors.id_person}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormSelect
                            type="text"
                            name="status"
                            isDisabled={!isEdit}
                            label={i18n.get('schedules.status')}
                            onChange={option => setFieldValue('status', option.value)}
                            onBlur={handleBlur}
                            value={values.status}
                            error={errors.status}
                            touched={touched.status}
                            options={[
                                {label: 'A', value: 'A'},
                                {label: 'B', value: 'B'},
                                {label: 'F', value: 'F'},
                                {label: 'I', value: 'I'},
                                {label: 'U', value: 'U'},
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="room"
                            label={i18n.get('schedules.room')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.room}
                            error={errors.room}
                            touched={touched.room}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="date"
                            name="day"
                            label={i18n.get('schedules.day')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.day}
                            error={errors.day}
                            touched={touched.day}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="time"
                            name="start"
                            label={i18n.get('schedules.start')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.start}
                            error={errors.start}
                            touched={touched.start}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormDate
                            type="time"
                            name="end"
                            label={i18n.get('schedules.end')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.end}
                            error={errors.end}
                            touched={touched.end}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="topic"
                            label={i18n.get('schedules.topic')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.topic}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/schedules/${values.id}`}
                                confirmMessage={i18n.get('contacts.confirm_message')}
                                successMessage={i18n.get('contacts.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('schedules.update') : i18n.get('schedules.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default ScheduleFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Schedules/ScheduleFormFields.js